import React from 'react';
import styled from '@emotion/styled';
import { StatusBadge } from '../../badges';
import CollapsiblePanel from '../../panels/CollapsiblePanel';
import ErrorDetails from './error-details/ErrorDetails';
import { StatusType } from '../../badges';
import Delete from '../actions/Delete';
import Retry from '../actions/Retry';
import DownloadRawFiles from '../actions/DownloadRawFiles';

const AdminContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  width: 100%;

  @media (max-width: 1740px) {
    max-width: 59.75rem;
  }

  @media (max-width: 1245px) {
    max-width: 29.125rem;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0;
  padding: 1rem;

  & > button:not(:last-child) {
    margin-right: 1rem;
  }

  @media (max-width: 1245px) {
    max-width: 29.125rem;
    flex-direction: column;

    & > button:not(:last-child) {
      margin-right: 0;
      margin-bottom: 1rem;
    }
  }
`;

const AdminTitle = styled.div`
  display: flex;
  align-items: center;

  p {
    margin: 0;
    margin-right: 1rem;
  }
`;

interface Props {
  id: number;
  apiUrl?: string;
  status: StatusType | string;
  errorDetails?: string;
}

export const AdminPanel = (props: Props) => {
  const { status, errorDetails, apiUrl, id } = props;

  const adminTitle = (
    <AdminTitle>
      <p>Admin Controls</p> <StatusBadge status={status as StatusType} />
    </AdminTitle>
  );

  return (
    <AdminContainer>
      <CollapsiblePanel title={adminTitle} expanded={false}>
        <ButtonContainer>
          <DownloadRawFiles id={id} apiUrl={apiUrl} />
          <Retry id={id} apiUrl={apiUrl} />
          <Delete id={id} apiUrl={apiUrl} />
        </ButtonContainer>
        {status === StatusType.ERROR && <ErrorDetails details={errorDetails ? errorDetails : ''} />}
      </CollapsiblePanel>
    </AdminContainer>
  );
};

export default AdminPanel;
